import React from 'react';
import PhotoSetThumbnailView from './PhotoSetThumbnailView';

class PhotoSetSlider extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            thumbnailsNo: 20
        }
    }

    componentDidMount() {
    }

    componentDidUpdate(prevProps) {
        this.props.bounds !== prevProps.bounds
            && this.setState({thumbnailsNo: 20});
    }

    addThumbnails() {
        this.setState({thumbnailsNo: this.state.thumbnailsNo += 10});
        this.forceUpdate();
    }

    handleActivePhotoSetChange(photoSet) {
        if (this.props.onActivePhotoSetChange)
            this.props.onActivePhotoSetChange(photoSet);
    }

    render() {
        return (
            <div className="photo-slider">
                { this.props.visiblePhotoSets.slice(0, this.state.thumbnailsNo).map(photoSet => {
                    return  (
                        <div  className="photo-slider-slide" key={photoSet.id} onClick={() => this.handleActivePhotoSetChange(photoSet)}>
                            <PhotoSetThumbnailView photoSet={photoSet} showControls={false} />
                        </div>
                    )
                })}
                {this.props.visiblePhotoSets.length > 20 && <span onClick={() => this.addThumbnails()}>Add</span>}
            </div>
        );
    }
}

export default PhotoSetSlider;



// WEBPACK FOOTER //
// ./src/components/PhotoSetSlider.js